import { Record } from 'immutable';
import { isEmpty } from 'lodash';
import {
  REQUEST_DAYS_OFF,
  RECEIVE_DAYS_OFF,
} from '../constants';

const InitialState = Record({
  items: [],
  isFetching: false,
  updatedAt: null,
});

const initialState = new InitialState();

export default function daysOffReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_DAYS_OFF:
      return state.set('isFetching', true).set('items', []).set('updatedAt', Date.now());

    case RECEIVE_DAYS_OFF: {
      if (isEmpty(action.payload)) return state.set('isFetching', false);

      return state.withMutations(s =>
        s.set('items', action.payload)
          .set('isFetching', false)
          .set('updatedAt', Date.now())
      );
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/daysOff/reducer.js